import { useQuery } from '@hooks/reactQuery';

import { getRUConfigurationNetconfs } from '@api/ruConfigurations';

import { optionsFormatted } from '@utils/formatter';

import { TNameTitle } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_CONFIGURATIONS_NETCONFS } from '@constants/queryKeys';

interface IUseQueryRUConfigurationNetconfsReturned {
	ruConfigurationNetconfs: TSelectOption<string>[];
	isLoadingRUConfigurationNetconfs: boolean;
}

export const useQueryRUConfigurationNetconfs = (): IUseQueryRUConfigurationNetconfsReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<TNameTitle[], TSelectOption<string>[]>({
		queryKey: [RU_CONFIGURATIONS_NETCONFS],
		queryFn: getRUConfigurationNetconfs,
		select: (data) => optionsFormatted(data),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		ruConfigurationNetconfs: data || [],
		isLoadingRUConfigurationNetconfs: isInitialLoading,
	};
};
